import ApiService from "./ApiService";
import Message from "./models/Message";
import { groupBy } from "@/utilities";

const MessagesService = {
  getMessages: async () => {
    try {
      let res = await ApiService.get(`/message/`);
      return res.data.length ? res.data.map(el => new Message(el)) : [];
    } catch (err) {
      console.log(err);
    }
  },
  checkUnreadMessages: async () => {
    try {
      let res = await ApiService.get(`/message/?unread=true`);
      return res.data.length ? res.data.map(el => new Message(el)) : [];
    } catch (err) {
      console.log(err);
    }
  },
  checkNewMessages: async () => {
    try {
      let res = await ApiService.get(`/message/has-new/`);
      return res.data;
    } catch (err) {
      console.log(err);
    }
  },
  getGroupedByAppointmentMessages: messages => {
    return messages.length > 0 ? groupBy(messages, "appointment") : "";
  }
};
export default MessagesService;
